<i18n>
{
  "fr": {  
    "indicator-general-help": "Aide"
  },
  "en": {
    "indicator-general-help": "Help"
  }
}
</i18n>
<template>
  <b-tab-item v-if="indicator" class="pt-24px" :value="tabName">
    <template #header>
      {{ $t('indicator-general-help') }}
      <b-icon icon="question-circle has-text-grey-light" size="is-small" class="mr-0" />
    </template>
    <!-- Tiroirs -->
    <hr class="is-marginless" />
    <prismic-content :doctype="DOCUMENT_TYPE_INDICATOR" :uid="indicator.prismicUid" v-slot="{ content }">
      <template v-if="content && content.drawers">
        <div v-for="(drawer, index) of content.drawers" :key="index">
          <ui-drawer>
            <template #title>
              <span class="has-text-link">{{ $prismicText(drawer.drawer_title) }}</span>
            </template>
            <prismic-rich-text class="content is-custom has-max-width-768" :field="drawer.drawer_content" />
          </ui-drawer>
          <hr class="is-marginless" />
        </div>
      </template>
    </prismic-content>
  </b-tab-item>
</template>
<script>
import { DOCUMENT_TYPE_INDICATOR } from '@/consts/prismic'
import PrismicContent from '@/components/prismic/prismic-content'
import UiDrawer from '@/components/ui/drawer'

export default {
  components: {
    PrismicContent,
    UiDrawer
  },
  props: {
    indicator: { type: Object, required: true },
    tabName: { type: String, required: true }
  },
  data() {
    return {
      DOCUMENT_TYPE_INDICATOR
    }
  }
}
</script>